import { BillingDownloadsComponent } from './components/billing-downloads/billing-downloads.component';
import { NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

// PIPES
import { AgePipe } from './pipes/age.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { OrderModule } from 'ngx-order-pipe';
import { MyFilterSwPipe } from './pipes/my-filter-sw.pipe';
import { FilterAssocPipe } from './pipes/filter-assoc.pipe';

// IMPORTS
import { FlatpickrModule } from 'angularx-flatpickr';
import { ImageDrawingModule } from 'ngx-image-drawing';
import { QRCodeModule } from 'angularx-qrcode';
import { JoyrideModule } from 'ngx-joyride';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { MaterialModule } from './material.module';
// COMPONENTS
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { ControlMessagesComponent } from './components/control-messages/control-messages.component';
import { PhoneInputComponent } from './components/phone-input/phone-input.component';
import { CommonFooterComponent } from './components/common-footer/common-footer.component';
import { CommonNavbarComponent } from './components/common-navbar/common-navbar.component';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { ProfilePopupComponent } from './components/profile-popup/profile-popup.component';
import { ProfilePopupStaffComponent } from './components/profile-popup-staff/profile-popup-staff.component';
import { PasswordChangeComponent } from './components/password-change/password-change.component';
import { PatientSearchTypeaheadComponent } from './components/patient-search-typeahead/patient-search-typeahead.component';
import { PatientSearchNewComponent } from './components/patients/patient-search-new/patient-search-new.component';
import { PatientFilterDialogComponent } from './components/patients/patient-filter-dialog/patient-filter-dialog.component';
import { AssociateSearchTypeaheadComponent } from './components/associates/associate-search-typeahead/associate-search-typeahead.component';
import { PatientNewFormComponent } from './components/patients/patient-new-form/patient-new-form.component';
import { PatientMinimalFormComponent } from './components/patients/patient-minimal-form/patient-minimal-form.component';
import { CommonBillDetailsComponent } from './components/common-bill-details/common-bill-details.component';
import { BillProductsTableComponent } from './components/common-bill-details/bill-products-table/bill-products-table.component';
import { ViewBillDetailsComponent } from './components/view-bill-details/view-bill-details.component';
import { BillspaymentsFormBillComponent } from './components/billspayments-form-bill/billspayments-form-bill.component';
import { PrintTemplateComponent } from './components/prints/print-template/print-template.component';
import { WaitlistSidebarComponent } from './components/waitlist-sidebar/waitlist-sidebar.component';
import { SideDrawerComponent } from './components/side-drawer/side-drawer.component';
import { PrintTemplateLetterComponent } from './components/prints/print-template-letter/print-template-letter.component';
import { PrintRecallComponent } from './components/prints/print-recall/print-recall.component';
import { PrintHalfLetterTemplateComponent } from './components/prints/print-half-letter-template/print-half-letter-template.component';
import { PrintLetterTemplateComponent } from './components/prints/print-letter-template/print-letter-template.component';
import { NoteFormComponent } from './components/patients/note-form/note-form.component';
import { SmsPopupFormComponent } from './components/sms/sms-popup-form/sms-popup-form.component';
import { LoadSmsCreditsFormComponent } from './components/sms/load-sms-credits-form/load-sms-credits-form.component';
import { ImageEditInlineComponent } from './components/patients/image-edit-inline/image-edit-inline.component';
import { ImageEditPopupComponent } from './components/patients/image-edit-popup/image-edit-popup.component';
import { FollowUpFormComponent } from '@app/practice/patients/follow-ups/follow-up-form/follow-up-form.component';
import { SelectTeethModelsComponent } from './components/select-teeth-models/select-teeth-models.component';
import { ProfileSwitcherComponent } from './components/profile-switcher/profile-switcher.component';
import { SignaturePadPatientComponent } from './components/signature-pad-patient/signature-pad-patient.component';
import { SignaturePadPopupComponent } from './components/signature-pad-popup/signature-pad-popup.component';
import { AdminTourComponent } from './components/virtual-tour/admin-tour/admin-tour.component';
import { PracticeTourComponent } from './components/virtual-tour/practice-tour/practice-tour.component';
import { PrintCovidAssessmentComponent } from './components/prints/print-covid-assessment/print-covid-assessment.component';
import { BuyCreditsComponent } from './components/sms/buy-credits/buy-credits.component';
import { AccountDisabledComponent } from './components/account-disabled/account-disabled.component';
import { TopnavNotificationsComponent } from './components/topnav-notifications/topnav-notifications.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { PayHitpayFormComponent } from './components/payments/pay-hitpay-form/pay-hitpay-form.component';
import { PrintCovidPpdsiAssessmentComponent } from './components/prints/print-covid-ppdsi-assessment/print-covid-ppdsi-assessment.component';
import { PpdsInformedConsentWaiverComponent } from './components/prints/ppds-informed-consent-waiver/ppds-informed-consent-waiver.component';
import { PrintCovidEsppbeAssessmentComponent } from './components/prints/print-covid-esppbe-assessment/print-covid-esppbe-assessment.component';
import { PrintCovidDohAssessmentComponent } from './components/prints/print-covid-doh-assessment/print-covid-doh-assessment.component';
import { PrintInformedConsentComponent } from './components/prints/print-informed-consent/print-informed-consent.component';
import { QrcodeGenPopupComponent } from './components/qrcode-gen-popup/qrcode-gen-popup.component';
import { ConsentCovidFormComponent } from './components/consents/consent-covid-form/consent-covid-form.component';
import { CovidDohFormComponent } from './components/consents/covid-doh-form/covid-doh-form.component';
import { CovidEsppbeFormComponent } from './components/consents/covid-esppbe-form/covid-esppbe-form.component';
import { CovidPpdsiFormComponent } from './components/consents/covid-ppdsi-form/covid-ppdsi-form.component';
import { BulkSmsFormComponent } from './components/sms/bulk-sms-form/bulk-sms-form.component';
import { InformedConsentComponent } from './components/consents/informed-consent/informed-consent.component';
import { ExpenseFormComponent } from './components/expenses/expense-form/expense-form.component';
import { MoveApptFormComponent } from './components/patients/move-appt-form/move-appt-form.component';
import { ChangeEmailComponent } from './components/change-email/change-email.component';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { BuyMoreStorageComponent } from './components/storage/buy-more-storage/buy-more-storage.component';
import { CommonAddPaymentFormComponent } from './components/common-add-payment-form/common-add-payment-form.component';
import { CommonApplyAccountCreditFormComponent } from './components/common-apply-account-credit-form/common-apply-account-credit-form.component';
import { FormatNumberWithCommaComponent } from './components/format-number-with-comma/format-number-with-comma.component';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { PesoPipe } from './pipes/peso.pipe';
import { ToothNumberPipe } from './pipes/tooth-number.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { PrintGenerationComponent } from './components/prints/print-generation/print-generation.component';
import { CachedImageComponent } from './components/cached-image/cached-image.component';
import { ImageThumbnailComponent } from './components/image-thumbnail/image-thumbnail.component';
import { PaymentDatePopupComponent } from './components/payment-date-popup/payment-date-popup.component';
import { CommonBulkPaymentFormComponent } from './components/common-bulk-payment-form/common-bulk-payment-form.component';
import { InputMatChipsComponent } from './components/input-mat-chips/input-mat-chips.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { CommissionFilterComponent } from './components/commission-filter/commission-filter.component';
import { CustomInputServiceComponent } from './components/custom-input-service/custom-input-service.component';
import { CustomInputProcedureCategoryComponent } from './components/custom-input-procedure-category/custom-input-procedure-category.component';
import { FieldCheckboxOptionPopupComponent } from './components/field-checkbox-option-popup/field-checkbox-option-popup.component';
import { CalendarListComponent } from './components/calendar-list/calendar-list.component';
import { CommonTableComponent } from './components/common-table/common-table.component';
import { QrcodeUuidPopupComponent } from './components/qrcode-uuid-popup/qrcode-uuid-popup.component';
import { FabricImageDrawingComponent } from './components/patients/fabric-image-drawing/fabric-image-drawing.component';
import { TaggingModalComponent } from './components/tagging-modal/tagging-modal.component';
import { SurveyFeedbackModalComponent } from './components/survey-feedback-modal/survey-feedback-modal.component';
import { DeviceAssignmentModalComponent } from './components/device-assignment-modal/device-assignment-modal.component';
import { SurveyComponent } from './components/survey/survey.component';
import { SurveyModule } from 'survey-angular-ui';
import { AuditLogViewerComponent } from './components/audit-log-viewer/audit-log-viewer.component';
import { VisitRestampDialogComponent } from './components/visit-restamp-dialog/visit-restamp-dialog.component';
import { WaitlistVisitTimesFormComponent } from './components/waitlist-visit-times-form/waitlist-visit-times-form.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { InventoryProductsInlineFormComponent } from '@app/inventory/components/inventory-products-inline-form/inventory-products-inline-form.component';
import { InventorySearchAutocompleteComponent } from '@app/inventory/components/inventory-search-autocomplete/inventory-search-autocomplete.component';
import { WebcamModule } from 'ngx-webcam';
import { ProfilePhotoUploaderComponent } from './components/patients/profile-photo-uploader/profile-photo-uploader.component';
import { PatientHeaderComponent } from './components/patients/patient-header/patient-header.component';
import { ProfilePhotoUpdateComponent } from './components/profile-photo-update/profile-photo-update.component';
import { RegisterDeviceModalComponent } from './components/register-device-modal/register-device-modal.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ClinicSwitchConfirmDialogComponent } from './components/clinic-switch-confirm-dialog/clinic-switch-confirm-dialog.component';
import { SpeechDictationComponent } from './components/speech-dictation/speech-dictation.component';
import { AiClinicalItemSuggestionsComponent } from './components/ai-clinical-item-suggestions/ai-clinical-item-suggestions.component';
import { TranscriptionDialogComponent } from './components/transcription-dialog/transcription-dialog.component';

@NgModule({
  exports: [
    CommonModule,
    ToggleFullscreenDirective,
    NgbModule,
    ControlMessagesComponent,
    PhoneInputComponent,
    CommonFooterComponent,
    CommonNavbarComponent,
    ProfileMenuComponent,
    PatientSearchTypeaheadComponent,
    PatientSearchNewComponent,
    PatientFilterDialogComponent,
    AssociateSearchTypeaheadComponent,
    PatientNewFormComponent,
    CommonBillDetailsComponent,
    BillProductsTableComponent,
    PrintTemplateComponent,
    PrintTemplateLetterComponent,
    PrintRecallComponent,
    WaitlistSidebarComponent,
    SideDrawerComponent,
    AgePipe,
    MyFilterSwPipe,
    FilterAssocPipe,
    NoteFormComponent,
    SmsPopupFormComponent,
    ImageEditPopupComponent,
    ImageEditInlineComponent,
    ProfileSwitcherComponent,
    SignaturePadPatientComponent,
    AdminTourComponent,
    PracticeTourComponent,
    BuyCreditsComponent,
    PayHitpayFormComponent,
    AccountDisabledComponent,
    TopnavNotificationsComponent,
    BillingDownloadsComponent,
    ExpenseFormComponent,
    PrintLetterTemplateComponent,
    PrintHalfLetterTemplateComponent,
    MoveApptFormComponent,
    ChangeEmailComponent,
    BuyMoreStorageComponent,
    CommonAddPaymentFormComponent,
    CommonApplyAccountCreditFormComponent,
    NumberFormatPipe,
    PesoPipe,
    ToothNumberPipe,
    DurationPipe,
    FormatNumberWithCommaComponent,
    CachedImageComponent,
    ImageThumbnailComponent,
    PaymentDatePopupComponent,
    CommonBulkPaymentFormComponent,
    InputMatChipsComponent,
    CommissionFilterComponent,
    CustomInputServiceComponent,
    CustomInputProcedureCategoryComponent,
    FieldCheckboxOptionPopupComponent,
    CalendarListComponent,
    QrcodeUuidPopupComponent,
    FabricImageDrawingComponent,
    TaggingModalComponent,
    CommonTableComponent,
    SurveyFeedbackModalComponent,
    SurveyComponent,
    AuditLogViewerComponent,
    VisitRestampDialogComponent,
    WaitlistVisitTimesFormComponent,
    UnsubscribeComponent,
    DeviceAssignmentModalComponent,
    InventoryProductsInlineFormComponent,
    InventorySearchAutocompleteComponent,
    ViewBillDetailsComponent,
    ProfilePhotoUploaderComponent,
    PatientHeaderComponent,
    ProfilePhotoUpdateComponent,
    RegisterDeviceModalComponent,
    ConfirmationDialogComponent,
    ClinicSwitchConfirmDialogComponent,
    SpeechDictationComponent,
    AiClinicalItemSuggestionsComponent,
    TranscriptionDialogComponent,
  ],
  imports: [
    A11yModule,
    MaterialModule,
    MatChipsModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatListModule,
    MatFormFieldModule,
    MatOptionModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    OrderModule,
    FlatpickrModule,
    NgxPaginationModule,
    FilterPipeModule,
    ImageDrawingModule,
    CreditCardDirectivesModule,
    AngularSignaturePadModule,
    JoyrideModule,
    QRCodeModule,
    QuillModule,
    MaterialModule,
    ReactiveFormsModule,
    NgbNavModule,
    SurveyModule,
    PhoneInputComponent,
    WebcamModule
  ],
  declarations: [
    ToggleFullscreenDirective,
    ControlMessagesComponent,
    CommonFooterComponent,
    CommonNavbarComponent,
    AgePipe,
    ProfileMenuComponent,
    ProfilePopupComponent,
    ProfilePopupStaffComponent,
    PasswordChangeComponent,
    PatientSearchTypeaheadComponent,
    PatientSearchNewComponent,
    PatientFilterDialogComponent,
    AssociateSearchTypeaheadComponent,
    PatientNewFormComponent,
    PatientMinimalFormComponent,
    CommonBillDetailsComponent,
    BillProductsTableComponent,
    ViewBillDetailsComponent,
    PatientMinimalFormComponent,
    CommonBillDetailsComponent,
    ViewBillDetailsComponent,
    BillspaymentsFormBillComponent,
    PrintTemplateComponent,
    WaitlistSidebarComponent,
    SideDrawerComponent,
    PrintTemplateLetterComponent,
    PrintRecallComponent,
    PrintHalfLetterTemplateComponent,
    PrintLetterTemplateComponent,
    MyFilterSwPipe,
    NoteFormComponent,
    FilterAssocPipe,
    SmsPopupFormComponent,
    LoadSmsCreditsFormComponent,
    ImageEditInlineComponent,
    ImageEditPopupComponent,
    SelectTeethModelsComponent,
    ProfileSwitcherComponent,
    SignaturePadPatientComponent,
    SignaturePadPopupComponent,
    AdminTourComponent,
    PracticeTourComponent,
    PrintCovidAssessmentComponent,
    BuyCreditsComponent,
    AccountDisabledComponent,
    TopnavNotificationsComponent,
    BillingDownloadsComponent,
    NotificationsComponent,
    PayHitpayFormComponent,
    PrintCovidPpdsiAssessmentComponent,
    PpdsInformedConsentWaiverComponent,
    PrintCovidEsppbeAssessmentComponent,
    PrintCovidDohAssessmentComponent,
    PrintInformedConsentComponent,
    QrcodeGenPopupComponent,
    QrcodeUuidPopupComponent,
    ConsentCovidFormComponent,
    CovidDohFormComponent,
    CovidEsppbeFormComponent,
    CovidPpdsiFormComponent,
    BulkSmsFormComponent,
    InformedConsentComponent,
    ExpenseFormComponent,
    MoveApptFormComponent,
    ChangeEmailComponent,
    BuyMoreStorageComponent,
    CommonAddPaymentFormComponent,
    CommonApplyAccountCreditFormComponent,
    FormatNumberWithCommaComponent,
    CachedImageComponent,
    ImageThumbnailComponent,
    NumberFormatPipe,
    PesoPipe,
    ToothNumberPipe,
    DurationPipe,
    PrintGenerationComponent,
    PaymentDatePopupComponent,
    CommonBulkPaymentFormComponent,
    InputMatChipsComponent,
    CommissionFilterComponent,
    CustomInputServiceComponent,
    CustomInputProcedureCategoryComponent,
    FieldCheckboxOptionPopupComponent,
    CalendarListComponent,
    FabricImageDrawingComponent,
    CommonTableComponent,
    TaggingModalComponent,
    SurveyFeedbackModalComponent,
    SurveyComponent,
    FollowUpFormComponent,
    AuditLogViewerComponent,
    VisitRestampDialogComponent,
    WaitlistVisitTimesFormComponent,
    UnsubscribeComponent,
    DeviceAssignmentModalComponent,
    InventoryProductsInlineFormComponent,
    InventorySearchAutocompleteComponent,
    ViewBillDetailsComponent,
    ProfilePhotoUploaderComponent,
    PatientHeaderComponent,
    ProfilePhotoUpdateComponent,
    RegisterDeviceModalComponent,
    ConfirmationDialogComponent,
    ClinicSwitchConfirmDialogComponent,
    SpeechDictationComponent,
    AiClinicalItemSuggestionsComponent,
    TranscriptionDialogComponent,
  ],
  providers: [AgePipe, NumberFormatPipe, PesoPipe]
})
export class SharedModule { }
